import get from 'lodash/get';
import accounting from '~/misc/accounting';
const locationName = (location) => `${location.city}, ${location.state}`;

const isFlexible = (_text) => {
  // hack for book-now loads
  const text = _text && _text.toLowerCase();
  return text && (text.includes('flexibel') || text.includes('flexible'));
};

const toLegacyLoad = (item, createdAt) => ({
  original: item,
  source: item.origin,
  age: item.age,
  book_now: item.book_now,
  biddable: item.biddable,
  isFlexible: item.book_now && isFlexible(item.comments) || isFlexible(item.description),
  created_at: createdAt || item.created_at,
  comments: item.comments,
  description: item.description,
  broker_id: get(item, 'broker.id'),

  company: get(item, 'broker.company'),

  contact: get(item, 'broker.contact_name'),
  contact_first_name: get(item, 'broker.contact_name'),
  contact_last_name: '',
  // created_at: 1474627147788,
  deleted: item.deleted,
  checked: Boolean(item.is_save_loads),
  checkedBroker: Boolean(item.is_save_broker),

  phone: get(item, 'broker.phone.number') === "0" ? '- -' :get(item, 'broker.phone.number'),
  ['phone-ext']: get(item, 'broker.phone.ext'),

  distance: item.distance,
  dot: get(item, 'broker.dot'),
  mc: get(item, 'broker.mc'),
  email: get(item, 'broker.email'),
  equipment: item.equipment,
  equipment_detailed: item.equipment_detailed,

  // external_id: 'TP:3773',

  featured: item.featured,
  height: item.height,

  id: item.id,
  // is_favorite: false,
  // last_modified_at: '2016-09-23T10:39:07.789+0000',
  length: item.length,
  weight: item.weight,
  load_size: item.load_size,
  // offers_enabled: false,

  // refreshed_at: null,
  score: {
    score: get(item, 'broker.transcredit_rating.score'),
    days: get(item, 'broker.transcredit_rating.days_to_pay'),
  },
  // origin: 'truckerpath',
  // source: 'truckerpath',

  // shipper: {
  //   mc: '816635',
  //   dot: '2387910',
  //   email: 'tos-violation+3773@truckerpath.com',
  //   userId: 2297,
  // },
  // shipper_id: 'F03rxXXb75',

  target_price: item.price,
  rate_price: item.distance ? accounting.formatMoney(item.price / item.distance, {
    precision : 2,
  }) : 0,
  est_price: item.est_price,
  average_rate_price: "",
  address: '',
  from_address: '',
  from: locationName(get(item, 'pickup.address')),
  from_city: get(item, 'pickup.address.city'),
  from_date_local: get(item, 'pickup.date_local'),
  from_location: get(item, 'pickup.location'),
  from_state: get(item, 'pickup.address.state'),
  from_zip: get(item, 'pickup.address.zip'),

  to_address: '',
  to: locationName(get(item, 'drop_off.address')),
  to_city: get(item, 'drop_off.address.city'),
  to_date_local: get(item, 'drop_off.date_local'),
  to_location: get(item, 'drop_off.location'),
  to_state: get(item, 'drop_off.address.state'),
  to_zip: get(item, 'drop_off.address.zip'),

  deletedByBroker: get(item, 'deletedByBroker'),
});

export default toLegacyLoad;



// WEBPACK FOOTER //
// ./src/misc/toLegacyLoad.js